import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import ReleasesList from "./ReleasesList";
import ReleaseDetail from "./ReleaseDetail";
import DocumentationList from "./DocumentationList";
import DocumentationDetail from "./DocumentationDetail";

// prettier-ignore
const RoutesQuestion = () => {
    return (
        <>
            <Route path="releases/" element={<PrivateRoute role="tech"><ReleasesList /></PrivateRoute>} />
            <Route path="releases/:version" element={<PrivateRoute role="tech"><ReleaseDetail /></PrivateRoute>} />
            <Route path="documentation/" element={<PrivateRoute role="tech"><DocumentationList /></PrivateRoute>} />
            <Route path="documentation/:version" element={<PrivateRoute role="tech"><DocumentationDetail /></PrivateRoute>} />
        </>
    );
};
export default RoutesQuestion;
